var map = {
	"./": 1403,
	"./Clutch": 2731,
	"./Clutch.js": 2731,
	"./NewUi": 2732,
	"./NewUi.js": 2732,
	"./OldUi": 2733,
	"./OldUi.js": 2733,
	"./index": 1403,
	"./index.js": 1403,
	"./style": 868,
	"./style.js": 868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4286;